<template>
  <div class="columns">
    <b-field :label="$t('catalogue.newProduct.comptabilite.compteAnalytique.title')"
             class="column is-11">
      <b-autocomplete
        :open-on-focus="true"
        icon="magnify"
        :data="comptesAnalytiqueFilter"
        :value="search"
        :disabled="isDisabled"
        field="compteAnalytique"
        @input="getComptesAnalytique"
        :placeholder="$t('catalogue.newProduct.comptabilite.compteAnalytique.search')"
        @select="compteAnalytique => selectCompteAnalytique(compteAnalytique)">
        <template #header>
          <a @click="checkPermissions(constantes.COMPTE_ANALYTIQUE.maj)
                ? addNewCompteAnalytique() : showPopUp()">
                    <span  class="lien"
                           :class="{ 'text-access-no-permission' :
                     !checkPermissions(constantes.COMPTE_ANALYTIQUE.maj)}">
                      {{ $t('catalogue.newProduct.comptabilite.compteAnalytique.add') }}
                    </span>
          </a>
        </template>
      </b-autocomplete>
    </b-field>
    <a class="mgt-45px column is-1 is-paddingless" @click="deleteCompteAnalytique()"
       v-if="produit.compteAnalytiqueId && produit.regroupementProduitId == null">
      <b-icon  icon="delete-forever"
               type="is-danger">
      </b-icon>
    </a>
    <b-modal :active.sync="popUpAddCompteAnalytique" has-modal-card class="modal">
      <pop-up-compte-analytique :compte-analytique="compteAnalytiqueToAdd"
                                @reloadCompteAnalytique="selectCompteAnalytique"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { COMPTE_ANALYTIQUE } from '@/configuration/general/permissionsParametrageConf';
import popUpCompteAnalytique from '@/components/parametrage/compteAnalytique/p_addEditCompteAnalytique';

const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    popUpCompteAnalytique,
  },
  data() {
    return {
      search: null,
      comptesAnalytiqueFilter: [],
      popUpAddCompteAnalytique: false,
      constantes: {
        COMPTE_ANALYTIQUE,
      },
      compteAnalytiqueToAdd: null,
      iSelectCompteAnalytique: false,
      compteAnalytiqueSearch: null,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    comptesAnalytique() {
      return this.parametre(PARAMETRES_KEYS.compteAnalytique)
        .filter((compte) => {
          return compte.actif;
        });
    },
    isDisabled() {
      return this.disabled ?? this.produit.regroupementProduitId !== null;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    deleteCompteAnalytique() {
      this.search = null;
      this.produit.compteAnalytiqueId = null;
      this.compteAnalytiqueSearch = null;
    },
    addNewCompteAnalytique() {
      this.compteAnalytiqueToAdd = {
        societeId: this.produit.id ? this.produit.societeId : this.societeActiveId,
        compteAnalytique: this.compteAnalytiqueSearch,
        actif: true,
      };
      this.popUpAddCompteAnalytique = true;
    },
    getComptesAnalytique(search) {
      if (search === this.search) return;
      if (!search) {
        if (!this.iSelectCompteAnalytique) {
          this.produit.compteAnalytiqueId = null;
        }
        this.comptesAnalytiqueFilter = cloneDeep(this.comptesAnalytique);
        return;
      }
      this.compteAnalytiqueSearch = search;
      this.iSelectCompteAnalytique = false;
      this.produit.compteAnalytiqueId = null;
      this.comptesAnalytiqueFilter = cloneDeep(this.comptesAnalytique)
        .filter((compteAnalytique) => {
          return compteAnalytique.compteAnalytique.toLowerCase().includes(search.toLowerCase());
        });
    },
    selectCompteAnalytique(compteAnalytique) {
      if (!compteAnalytique) return;
      this.compteAnalytiqueSearch = cloneDeep(compteAnalytique.compteAnalytique);
      this.search = cloneDeep(compteAnalytique.compteAnalytique);
      this.produit.compteAnalytiqueId = cloneDeep(compteAnalytique.id);
      this.iSelectCompteAnalytique = true;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.compteAnalytique]);
      this.comptesAnalytiqueFilter = cloneDeep(this.comptesAnalytique);
      if (this.produit.compteAnalytiqueId) {
        this.search = this.parametre(PARAMETRES_KEYS.compteAnalytique).find((compte) => {
          return compte.id === this.produit.compteAnalytiqueId;
        }).compteAnalytique;
        this.compteAnalytiqueSearch = cloneDeep(this.search);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
